import constate from "constate";
import { useSubscriber } from "hooks/useSubscriber";

const useTicketNotifications = () => {
  const { addSubscription, notify, removeSubscription } = useSubscriber();

  return {
    notifyTicketUpdate: notify,
    subscribeTicketUpdates: addSubscription,
    unsubscribeTicketUpdates: removeSubscription,
  };
};

export const [TicketUpdatesProvider, useTicketUpdatesContext] = constate(useTicketNotifications);
